import { inferRouteObject } from 'react-router-typed-object';

import { Navigate } from '@/js/libs/router';
import { PrivateRoute, Roles } from '@/js/libs/use-auth';

import { AnalyticsTool } from 'src/scenes/AnalyticsTool/index.ts';
import Status from 'src/scenes/Status/index.ts';

const index = true;

export const analyticsToolObject = inferRouteObject({
  path: 'analytics-tool',
  element: <PrivateRoute roles={Roles.ANALYTICS_TOOL} noAccessComponent={Status.NotFound} />,
  children: [
    {
      Component: AnalyticsTool.Helmet,
      children: [
        { index, element: <Navigate to='./page-impressions' replace /> },
        { path: 'page-impressions', Component: AnalyticsTool.PageImpressions },
        { path: 'ad-impressions', Component: AnalyticsTool.AdImpressions },
      ],
    },
  ],
});
